
import React, { useState } from 'react';
import { FaTachometerAlt, FaUtensils, FaUsers, FaMoneyBill, FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const Sidebar = () => {
    // Retrieve saved dropdown states from localStorage
    const getStoredState = (key, defaultValue) => {
        const savedState = localStorage.getItem(key);
        return savedState ? JSON.parse(savedState) : defaultValue;
    };

    // State for each dropdown (independently controlled)
    const [ordersDropdownOpen, setOrdersDropdownOpen] = useState(getStoredState('ordersDropdownOpen', true));
    const [customersDropdownOpen, setCustomersDropdownOpen] = useState(getStoredState('customersDropdownOpen', true));
    const [eventDropdownOpen, setEventDropdownOpen] = useState(getStoredState('eventDropdownOpen', true));
    const [paymentsDropdownOpen, setPaymentsDropdownOpen] = useState(getStoredState('paymentsDropdownOpen', true));
    const [stockDropdownOpen, setstockDropdownOpen] = useState(getStoredState('stockDropdownOpen', true));
    const [couponDropdownOpen, setcouponDropdownOpen] = useState(getStoredState('couponDropdownOpen', true));

    // Toggle functions for each dropdown
    const toggleOrdersDropdown = () => {
        setOrdersDropdownOpen(prev => {
            const newState = !prev;
            localStorage.setItem('ordersDropdownOpen', JSON.stringify(newState)); // Save state to localStorage
            return newState;
        });
    };

    const toggleCustomersDropdown = () => {
        setCustomersDropdownOpen(prev => {
            const newState = !prev;
            localStorage.setItem('customersDropdownOpen', JSON.stringify(newState)); // Save state to localStorage
            return newState;
        });
    };

    const toggleEventDropdown = () => {
        setEventDropdownOpen(prev => {
            const newState = !prev;
            localStorage.setItem('eventDropdownOpen', JSON.stringify(newState)); // Save state to localStorage
            return newState;
        });
    };

    const togglePaymentsDropdown = () => {
        setPaymentsDropdownOpen(prev => {
            const newState = !prev;
            localStorage.setItem('paymentsDropdownOpen', JSON.stringify(newState)); // Save state to localStorage
            return newState;
        });
    };
    const stockDropdown = () => {
        setstockDropdownOpen(prev => {
            const newState = !prev;
            localStorage.setItem('stockDropdownOpen', JSON.stringify(newState)); // Save state to localStorage
            return newState;
        });
    };
    const couponDropdown = () => {
        setcouponDropdownOpen(prev => {
            const newState = !prev;
            localStorage.setItem('couponDropdownOpen', JSON.stringify(newState)); // Save state to localStorage
            return newState;
        });
    };
    // Rendering the dropdown items
    const renderDropdownItems = (items, isOpen) => {
        if (!isOpen) return null; // If the dropdown is closed, return nothing
        return (
            <ul className="ml-8">
                {items.map((item, index) => (
                    <li key={index} className="p-2 hover:bg-gray-100 flex items-center cursor-pointer">
                        <Link to={item.link}>{item.text}</Link>
                    </li>
                ))}
            </ul>
        );
    };

    // Dropdown data
    const dropdowns = [
        {
            title: 'Customers',
            icon: FaUsers,
            isOpen: customersDropdownOpen,
            toggle: toggleCustomersDropdown,
            items: [{ link: '/customerslist', text: 'Customers List' }]
        },
        {
            title: 'Orders',
            icon: FaUtensils,
            isOpen: ordersDropdownOpen,
            toggle: toggleOrdersDropdown,
            items: [
                { link: '/orderslist', text: ' Orders List' },
                { link: '/undeliveredorders', text: 'undeliveredorders' }

            ]
        },
        {
            title: 'Stocks',
            icon: FaUtensils,
            isOpen: stockDropdownOpen,
            toggle: stockDropdown,
            items: [
                { link: '/stock', text: 'Stock' },

                { link: '/purchase', text: 'Purchase Here' },

            ]
        },
        {
            title: 'Coupons & Cart Discounts',
            icon: FaUtensils,
            isOpen: couponDropdownOpen,
            toggle: couponDropdown,
            items: [
                { link: '/Createcoupon', text: 'Create Coupon' },

            ]
        },
        {
            title: 'Logistics',
            icon: FaUtensils,
            isOpen: ordersDropdownOpen,
            toggle: toggleOrdersDropdown,
            items: [
                { link: '/logistics', text: 'logistics' },

            ]
        },
        {
            title: 'Reports',
            icon: FaUtensils,
            isOpen: ordersDropdownOpen,
            toggle: toggleOrdersDropdown,
            items: [
                { link: '/report', text: 'stock reports for orders' },

            ]
        },


        {
            title: 'Products',
            icon: FaUtensils,
            isOpen: eventDropdownOpen,
            toggle: toggleEventDropdown,
            items: [
                { link: '/itemslist', text: 'Event ItemsList' },
                // { link: '/categories', text: 'Corporate Categories' }
            ]
        },
        {
            title: 'Payments',
            icon: FaMoneyBill,
            isOpen: paymentsDropdownOpen,
            toggle: togglePaymentsDropdown,
            items: [{ link: '/paymentlist', text: 'Payment List' }]
        }
    ];

    return (
        <aside className="w-64 shadow-lg h-screen overflow-y-auto bg-white">
            <div className="p-4 font-bold text-orange-500 text-2xl sticky top-0 bg-white z-10 border-b">
                MeraCrackers
            </div>
            <nav className="mt-4 pb-6">
                <ul>
                    <li className="p-4 hover:bg-gray-100 flex items-center">
                        <FaTachometerAlt className="mr-3" />
                        <Link to="/dashboard">Dashboard</Link>
                    </li>
                    {dropdowns.map((dropdown, index) => (
                        <li key={index}>
                            <div className="p-4 hover:bg-gray-100 flex items-center cursor-pointer" onClick={dropdown.toggle}>
                                <dropdown.icon className="mr-3" />
                                {dropdown.title}
                                {dropdown.isOpen ? <FaChevronUp className="ml-auto" /> : <FaChevronDown className="ml-auto" />}
                            </div>
                            {renderDropdownItems(dropdown.items, dropdown.isOpen)}
                        </li>
                    ))}
                </ul>
            </nav>
        </aside>
    );
};

export default Sidebar;
